import { deleteDepots, getDepotsById } from '@spark/services/depots';
import { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { notification } from '@spark/ui-components/utils/notification';

export const useDepotDetalhes = () => {
  const { id } = useParams();
  const history = useHistory();
  const [depot, setDepot] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [activeTab, setActiveTab] = useState('detalhes');
  const didInitialLoadRef = useRef(false);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const loadDepot = useCallback(async () => {
    if (!id || !isMountedRef.current) return;

    try {
      const response = await getDepotsById(id);
      const depotData = response?.depot || response;
      if (isMountedRef.current) {
        setDepot(depotData || null);
      }
    } catch (error) {
      console.error('Erro ao carregar depot:', error);
      if (isMountedRef.current) {
        notification.error('Erro ao carregar depot');
      }
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  }, [id]);

  useEffect(() => {
    if (!id || !isMountedRef.current || didInitialLoadRef.current) return;
    didInitialLoadRef.current = true;

    (async () => {
      try {
        setLoading(true);
        await loadDepot();
      } finally {
        if (isMountedRef.current) setLoading(false);
      }
    })();
  }, [id, loadDepot]);

  const handleEditar = useCallback(() => {
    history.push(`/pages/containers/programacao/editar/${id}`);
  }, [history, id]);

  const handleVoltar = useCallback(() => {
    history.goBack();
  }, [history]);

  const handleExcluir = useCallback(() => {
    setShowDeleteModal(true);
  }, []);

  const confirmDelete = useCallback(async () => {
    if (!isMountedRef.current || !id) return;
    setDeleting(true);

    try {
      await deleteDepots(id);
      if (isMountedRef.current) {
        notification.success('Depot excluído com sucesso');
        setShowDeleteModal(false);
        history.push('/pages/containers/programacao');
      }
    } catch (error) {
      console.error('Erro ao excluir depot:', error);
      if (isMountedRef.current) {
        notification.error('Erro ao excluir depot');
      }
    } finally {
      if (isMountedRef.current) {
        setDeleting(false);
      }
    }
  }, [history, id]);

  const handleSuccess = useCallback(async () => {
    if (!isMountedRef.current) return;
    try {
      setLoading(true);
      await loadDepot();
      notification.success('Depot atualizado com sucesso!');
    } finally {
      if (isMountedRef.current) setLoading(false);
    }
  }, [loadDepot]);

  return {
    depot,
    loading,
    deleting,
    showDeleteModal,
    activeTab,
    setActiveTab,
    setShowDeleteModal,
    handleEditar,
    handleVoltar,
    handleExcluir,
    confirmDelete,
    handleSuccess,
    loadDepot,
  };
};
